import {
    BriefStore,
    PagePathStore,
    ReferrerStore,
    UserStore,
} from '../../../shared/mixpanel';
import { createProjectIdStore } from '../../../shared/mixpanel/stores/projectId';
import { createSellerIdStore } from '../../../shared/mixpanel/stores/sellerId';
import { createVariationIdStore } from '../../../shared/mixpanel/stores/variationId';

const store = {
    brief: new BriefStore(),
    user: new UserStore(),
    pagePath: new PagePathStore(),
    referrer: new ReferrerStore(),

    sellerId: createSellerIdStore(),
    projectId: createProjectIdStore(),
    variationId: createVariationIdStore(),
};

export default store;
